import VueI18n from 'vue-i18n'
import messages from 'src/i18n'
import store from '../store'
import { Cookies } from 'quasar'

let i18nInstance

export default async ({ app, Vue }) => {
  Vue.use(VueI18n)

  let currentLocale = store().getters.lang
  if (Cookies.has('lang')) {
    currentLocale = Cookies.get('lang')
  }

  // Set i18n instance on app
  i18nInstance = new VueI18n({
    locale: currentLocale,
    fallbackLocale: 'en-us',
    messages
  })

  app.i18n = i18nInstance

  app.i18n.languages = [
    { name: 'fa-ir', isoName: 'fa-ir', label: 'فارسی', rtl: true },
    { name: 'en-us', isoName: 'en-us', label: 'English', rtl: false }
  ]

  app.store.dispatch('set_lang', currentLocale)
}

export { i18nInstance }
